import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../../../../Styled/Button";
import { downloadImg } from "./PrintView";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ButtonBar = styled.section.withConfig({
  displayName: "PrintViewButtons__ButtonBar",
  componentId: "sc-9cld4h-0"
})(["display:flex;justify-content:flex-end;"]);
const PrintViewButtons = props => {
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    var _props$screenshot;
    (_props$screenshot = props.screenshot) === null || _props$screenshot === void 0 || _props$screenshot.then(() => setDisabled(false));
  }, [props.screenshot]);
  return /*#__PURE__*/_jsxs(ButtonBar, {
    children: [/*#__PURE__*/_jsx(Button, {
      primary: true,
      disabled: isDisabled,
      onClick: evt => {
        var _props$screenshot2;
        evt.preventDefault();
        (_props$screenshot2 = props.screenshot) === null || _props$screenshot2 === void 0 || _props$screenshot2.then(downloadImg);
      },
      children: "Download map"
    }), /*#__PURE__*/_jsx(Button, {
      primary: true,
      disabled: isDisabled,
      marginLeft: 1,
      onClick: evt => {
        evt.preventDefault();
        props.window.print();
      },
      children: "Print"
    })]
  });
};
export default PrintViewButtons;